<template>
 <form
  @submit.prevent="
   this.title === $t('callqueue.updateTimeSlot')
    ? updateTimeSlot(this.id, $t('timeSlotUpdatedSuccessfully'))
    : updateException(this.id, $t('exceptionUpdatedSuccessfully'))
  "
  class="space-y-8 divide-y divide-gray-200 form_padding z-10 border border-gray-200 rounded-md"
  method="POST"
 >
  <div class="pt-4 space-y-6 sm:pt-4 sm:space-y-5">
   <div>
    <h3 class="text-lg leading-6 font-medium text-gray-900">
     {{ this.title }}
    </h3>
    <p class="mt-1 max-w-2xl text-sm text-gray-500">{{ $t("callqueue.subTitle") }}.</p>
   </div>
   <div class="space-y-6 sm:space-y-5">
    <div
     v-if="this.title === $t('callqueue.updateTimeSlot')"
     class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5"
    >
     <label for="name" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
      {{ $t("callqueueTable.start") }}
     </label>
     <div class="mt-1 relative sm:mt-0 sm:col-span-2">
      <input
       v-model="this.form.start"
       @input="this.checkmakingTimeSlot()"
       type="time"
       required
       name="start-timeslot"
       id="start-timeslot"
       aria-invalid="true"
       :class="[
        this.checkmakingTimeSlot().checkStart ||
        this.checkmakingTimeSlot().checkBetween ||
        (this.pickedStartBigger && this.form.start && this.form.end)
         ? 'mt-1 ring-red-500 border-red-300 focus:ring-red-500 focus:border-red-500 block w-full shadow-sm sm:text-sm rounded'
         : 'mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded',
       ]"
      />
      <div
       v-if="
        this.checkmakingTimeSlot().checkStart ||
        this.checkmakingTimeSlot().checkBetween ||
        (this.pickedStartBigger && this.form.start && this.form.end)
       "
       class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
      >
       <ExclamationCircleIcon class="h-5 w-5 text-red-500" aria-hidden="true" />
      </div>
     </div>
     <p
      v-if="this.checkmakingTimeSlot().checkStart"
      class="col-start-2 -mt-3 ml-1 text-sm text-red-600"
      id="email-error"
     >
      {{ $t("callqueueTable.checkStart") }}
     </p>
     <p
      v-else-if="this.checkmakingTimeSlot().checkBetween"
      class="col-start-2 -mt-3 ml-1 text-sm text-red-600"
      id="email-error"
     >
      {{ $t("callqueueTable.checkBetween") }}
     </p>
     <p
      v-else-if="this.pickedStartBigger && this.form.start && this.form.end"
      class="col-start-2 -mt-3 ml-1 text-sm text-red-600"
      id="email-error"
     >
      {{ $t("callqueueTable.pickedStartBigger") }}
     </p>
    </div>
    <div
     v-if="this.title === $t('callqueue.updateTimeSlot')"
     class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5"
    >
     <label for="day" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
      {{ $t("callqueueTable.end") }}
     </label>
     <div class="mt-1 relative sm:mt-0 sm:col-span-2">
      <input
       v-model="this.form.end"
       @input="checkmakingTimeSlot()"
       type="time"
       required
       name="end-timeslot"
       id="end-timeslot"
       aria-invalid="true"
       :class="[
        this.checkmakingTimeSlot().checkEnd ||
        this.checkmakingTimeSlot().checkBetween ||
        (this.pickedStartBigger && this.form.start && this.form.end)
         ? 'mt-1 ring-red-500 border-red-300 focus:ring-red-500 focus:border-red-500 block w-full shadow-sm sm:text-sm rounded'
         : 'mt-1 focus:encom_border_input block w-full shadow-sm sm:text-sm border-gray-300 rounded',
       ]"
      />
      <div
       v-if="
        this.checkmakingTimeSlot().checkStart ||
        this.checkmakingTimeSlot().checkBetween ||
        (this.pickedStartBigger && this.form.start && this.form.end)
       "
       class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
      >
       <ExclamationCircleIcon class="h-5 w-5 text-red-500" aria-hidden="true" />
      </div>
     </div>
     <p
      v-if="this.checkmakingTimeSlot().checkStart"
      class="col-start-2 -mt-3 ml-1 text-sm text-red-600"
      id="email-error"
     >
      {{ $t("callqueueTable.checkStart") }}
     </p>
     <p
      v-else-if="this.checkmakingTimeSlot().checkBetween"
      class="col-start-2 -mt-3 ml-1 text-sm text-red-600"
      id="email-error"
     >
      {{ $t("callqueueTable.checkBetween") }}
     </p>
     <p
      v-else-if="this.pickedStartBigger && this.form.start && this.form.end"
      class="col-start-2 -mt-3 ml-1 text-sm text-red-600"
      id="email-error"
     >
      {{ $t("callqueueTable.pickedStartBigger") }}
     </p>
    </div>
    <div
     v-if="this.title === $t('callqueue.updateException')"
     class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5"
    >
     <label
      for="callqueue-number"
      class="capitalize block text-sm font-bold text-gray-700 sm:mt-px sm:pt-2"
     >
      {{ $t("callqueueTable.day") }}
     </label>
     <div class="mt-1 col-span-1 capitalize">
      <v-date-picker
       :min-date="new Date()"
       :locale="$i18n.locale"
       :attributes="attributes"
       v-model="this.form.day"
       @click="
        checkmakingOfBankHolidays(),
         checkmakingOfDate(),
         (this.closeNotification = true),
         (this.errorMessage = false)
       "
       title-position="left"
       trim-weeks
       is-expanded
       color="teal"
      >
      </v-date-picker>
     </div>
     <div v-if="this.form.day || this.errorMessage" class="col-span-1 border rounded p-2">
      <h3 class="text-lg pb-2 font-semibold leading-6 text-gray-900">
       {{ $t("callqueueTable.dateSelected") }}
      </h3>
      <p class="block capitalize text-base pb-2 text-gray-700">
       {{ this.fullFormatDateFrench(this.form.day) }}
      </p>

      <transition :name="computedTransition">
       <div
        v-if="this.closeNotification"
        :class="[
         !checkmakingOfDate() && !this.errorMessage
          ? 'rounded bg-green-50 p-4'
          : 'rounded bg-red-50 p-4',
        ]"
       >
        <div class="flex">
         <div class="flex-shrink-0">
          <CheckCircleIcon
           v-show="!checkmakingOfDate() && !this.errorMessage"
           class="h-5 w-5 text-green-400"
           aria-hidden="true"
          />
          <XCircleIcon
           v-show="checkmakingOfDate() || this.errorMessage"
           class="h-5 w-5 text-red-400"
           aria-hidden="true"
          />
         </div>
         <div class="ml-3">
          <p
           :class="[
            !checkmakingOfDate() && !this.errorMessage
             ? 'text-sm font-medium text-green-800'
             : 'text-sm font-bold text-red-800',
           ]"
          >
           {{
            !checkmakingOfDate() && !this.errorMessage
             ? $t("callqueueTable.newExceptionAdded")
             : $t("callqueueTable.newExceptionError")
           }}
          </p>

          <p v-show="checkmakingOfDate()" class="text-sm text-red-700">
           {{ $t("callqueueTable.newExceptionExist") }}
          </p>
          <p v-show="this.errorMessage" class="text-sm text-red-700">
           {{ $t("callqueueTable.selectExceptionError") }}
          </p>
         </div>
         <div class="ml-auto pl-3">
          <div class="-mx-1.5 -my-1.5">
           <button
            type="button"
            @click="this.closeNotification = false"
            :class="[
             !checkmakingOfDate() && !this.errorMessage
              ? 'inline-flex bg-green-50 rounded p-1.5 text-green-500 hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-green-50 focus:ring-green-600'
              : 'inline-flex bg-red-50 rounded p-1.5 text-red-500 hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-red-50 focus:ring-red-600',
            ]"
           >
            <span class="sr-only">Dismiss</span>
            <XIcon class="h-5 w-5" aria-hidden="true" />
           </button>
          </div>
         </div>
        </div>
       </div>
      </transition>
      <label for="reference" class="capitalize block text-sm font-normal pt-5 text-gray-700">
       {{ $t("callqueueTable.reference") }}
      </label>
      <input
       v-model="this.form.reference"
       required
       type="text"
       name="reference"
       id="reference"
       :placeholder="this.exceptionReference"
       class="mt-1 focus:encom_border_input block w-full shadow-sm sm:text-sm border-gray-300 rounded"
      />
     </div>
    </div>

    <div
     v-if="this.title === $t('callqueue.updateTimeSlot')"
     class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5"
    >
     <label
      for="reference"
      class="capitalize block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
     >
      {{ $t("callqueueTable.reference") }}
     </label>
     <div class="mt-1 sm:mt-0 sm:col-span-2">
      <input
       v-model="this.form.reference"
       type="text"
       name="reference"
       id="reference"
       class="mt-1 focus:encom_border_input block w-full shadow-sm sm:text-sm border-gray-300 rounded"
       :placeholder="this.exceptionReference"
      />
     </div>
    </div>
    <div
     v-if="!this.callQueueGroupExceptionId"
     class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5"
    >
     <label for="destination" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
      Destination
     </label>
     <div class="mt-1 sm:mt-0 sm:col-span-2">
      <input
       v-model="this.form.destination"
       type="tel"
       name="destination"
       id="destination"
       class="mt-1 focus:encom_border_input block w-full shadow-sm sm:text-sm border-gray-300 rounded"
       :placeholder="this.exceptionDestination"
      />
     </div>
    </div>
   </div>
  </div>

  <div class="pt-5">
   <div class="flex justify-end">
    <a
     href="javascript:void(0)"
     v-on:click="$emit('closeForm')"
     class="rounded bg-white py-2 px-4 border border-gray-300 shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50"
    >
     {{ $t("cancel") }}
    </a>
    <button
     type="submit"
     class="capitalize rounded ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium body__table--header text-white"
    >
     {{ $t("validate") }}
    </button>
   </div>
  </div>
 </form>

 <ComfirmationDialog
  v-if="this.showMessage"
  :messageToShow="this.messageToShow"
  :subMessageToShow="this.subMessageToShow"
 />
</template>

<script>
import axios from "axios";
import ComfirmationDialog from "./ConfirmationDialog.vue";
import {
 ExclamationIcon,
 ExclamationCircleIcon,
 CheckCircleIcon,
 SelectorIcon,
 XCircleIcon,
 XIcon,
} from "@heroicons/vue/solid";
const account = localStorage.getItem("account");
export default {
 props: [
  "id",
  "callQueueGroupTimeSlot",
  "callQueueGroupTimeSpansId",
  "callQueueGroupExceptionId",
  "call_queue_time_spans",
  "call_queue_group_time_spans",
  "dayOfWeek",
  "fullDate",
  "call_queue_exceptions",
  "call_queue_group_exceptions",
  "title",
  "exceptionReference",
  "exceptionDestination",
  "formatDateFrench",
  "fullFormatDateFrench",
 ],
 components: {
  ComfirmationDialog,
  ExclamationIcon,
  ExclamationCircleIcon,
  CheckCircleIcon,
  SelectorIcon,
  XCircleIcon,
  XIcon,
 },
 data() {
  return {
   frenchHolidaysDateOver12Months: [],
   form: {
    number: "",
    day: "",
    name: "",
    code: "",
    fullDate: "",
    dayOfWeek: "",
    start: "",
    end: "",
    reference: "",
    destination: "",
   },
   account,
   errorMessage: false,
   closeNotification: true,
   withTransition: true,
   showMessage: false,
   messageToShow: "",
   subMessageToShow: "",
  };
 },
 methods: {
  async getFrenchHolidaysOver12Months() {
   const res = await axios.get(
    `${this.$cookie.getCookie("API")}/api/v1/helpers/time/frenchHolidaysOver12Months`,

    {
     headers: {
      "Content-Type": "application/json",
     },
    }
   );

   try {
    this.frenchHolidaysOver12Months = res.data.response;
    for (const key in this.frenchHolidaysOver12Months) {
     if (Object.hasOwnProperty.call(this.frenchHolidaysOver12Months, key)) {
      this.frenchHolidaysDateOver12Months.push(this.frenchHolidaysOver12Months[key]);
     }
    }
   } catch (error) {
    this.errorHandling(error);
   }
  },
  updateTimeSlot(id, msg) {
   if (this.callQueueGroupTimeSpansId) {
    const options = {
     method: "PUT",
     url: `${this.$cookie.getCookie("API")}/api/v1/callQueueGroupTimeSpans/${
      this.callQueueGroupTimeSpansId
     }`,
     params: {
      customerAccount: this.account,
     },
     headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
     },
     data: {
      start: this.form.start,
      end: this.form.end,
      reference: this.form.reference,
     },
    };

    axios
     .request(options)
     .then((res) => {
      this.$emit("activeBanner");
      this.$emit("success", true);
      this.$emit("successMsg", msg);
     })
     .catch((error) => {
      this.errorHandling(error);
     });
   } else {
    const options = {
     method: "PUT",
     url: `${this.$cookie.getCookie("API")}/api/v1/callQueueTimeSpans/${id}`,
     params: {
      customerAccount: this.account,
     },
     headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
     },
     data: {
      start: this.form.start,
      end: this.form.end,
      reference: this.form.reference,
      destination: this.form.destination,
     },
    };

    axios
     .request(options)
     .then((res) => {
      this.$emit("activeBanner");
      this.$emit("success", true);
      this.$emit("successMsg", msg);
     })
     .catch((error) => {
      this.errorHandling(error);
     });
   }
  },
  updateException(id, msg) {
   if (this.callQueueGroupExceptionId) {
    const options = {
     method: "PUT",
     url: `${this.$cookie.getCookie("API")}/api/v1/callQueueGroupExceptions/${
      this.callQueueGroupExceptionId
     }`,
     params: {
      customerAccount: this.account,
     },
     headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
     },
     data: { day: this.form.day, reference: this.form.reference },
    };

    if (this.form.day && !this.checkmakingOfDate()) {
     axios
      .request(options)
      .catch((err) => {
       if (err.response) {
        if (err.response.status == 500) {
         window.alert("Oups, something went wrong...\nReason: " + err.response.statusText);
        } else if (err.response.status == 404) {
         window.alert("Document " + err.response.statusText);
        }
       }
      })
      .then((res) => {
       this.$emit("activeBanner");
       this.$emit("success", true);
       this.$emit("successMsg", msg);
      });
    } else if (!this.form.day) {
     this.errorMessage = true;
    } else {
    }
   } else {
    const options = {
     method: "PUT",
     url: `${this.$cookie.getCookie("API")}/api/v1/callQueueExceptions/${id}`,
     params: {
      customerAccount: this.account,
     },
     headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
     },
     data: {
      day: this.form.day,
      reference: this.form.reference,
      destination: this.form.destination,
     },
    };
    if (this.form.day && !this.checkmakingOfDate()) {
     axios
      .request(options)
      .catch((err) => {
       if (err.response) {
        if (err.response.status == 500) {
         window.alert("Oups, something went wrong...\nReason: " + err.response.statusText);
        } else if (err.response.status == 404) {
         window.alert("Document " + err.response.statusText);
        }
       }
      })
      .then((res) => {
       this.$emit("activeBanner");
       this.$emit("success", true);
       this.$emit("successMsg", msg);
      });
    } else if (!this.form.day) {
     this.errorMessage = true;
    } else {
    }
   }
  },
  checkmakingOfDate() {
   if (this.call_queue_group_exceptions) {
    let pickedDay = JSON.stringify(this.form.day).slice(1, 11) + "T00:00:00.000000Z";
    let day = this.call_queue_group_exceptions.find((day) => day.day === pickedDay);
    if (day) {
     return true;
    } else {
     return false;
    }
   } else {
    let pickedDay = JSON.stringify(this.form.day).slice(1, 11) + "T00:00:00.000000Z";
    let day = this.call_queue_exceptions.find((day) => day.day === pickedDay);
    if (day) {
     return true;
    } else {
     return false;
    }
   }
  },
  checkmakingOfBankHolidays() {
   this.form.reference = null;
   let pickedDay = JSON.stringify(this.form.day).slice(1, 11) + "T00:00:00.000000Z";
   let bankHolyday = this.frenchHolidaysDateOver12Months.find(
    (bankHolyday) => this.formatDateFrench(bankHolyday) === this.formatDateFrench(pickedDay)
   );
   for (const [frenchHolidays, date] of Object.entries(this.frenchHolidaysOver12Months)) {
    if (date === bankHolyday) {
     this.form.reference = frenchHolidays;
    }
   }
  },
  checkmakingTimeSlot() {
   let pickedStart = this.form.start;
   let pickedStartSplit = pickedStart.split(":");
   let pickedStartInt = parseInt(pickedStartSplit[0] + pickedStartSplit[1]);
   let pickedEnd = this.form.end;
   let pickedEndSplit = pickedEnd.split(":");
   let pickedEndInt = parseInt(pickedEndSplit[0] + pickedEndSplit[1]);
   let pickedDay = [];
   let checkDay = [];
   let timeSlotToEdit = [];
   let checkStart;
   let checkEnd;
   let checkBetween;
   this.pickedStartBigger = false;
   if (this.dayOfWeek) {
    pickedDay.push(this.dayOfWeek);
   } else {
    pickedDay.push(this.fullDate);
   }

   //Check if i'm inside a callqueue group detail
   if (this.call_queue_group_time_spans) {
    for (const value of pickedDay) {
     if (typeof value == "number") {
      const res = this.call_queue_group_time_spans.filter(
       (call_queue_group) => call_queue_group.dayOfWeek === value
      );
      if (res.length > 0 && pickedStartInt < pickedEndInt) {
       for (let index = 0; index < res.length; index++) {
        const timeSpans = res[index];
        checkDay.push(timeSpans);
        timeSlotToEdit = checkDay.filter((day) => day.id != this.id);
        checkStart = timeSlotToEdit.find(
         (checkStart) =>
          //Issue on only picked start
          //picked start bigger than existed start and smaller than existed end
          pickedStart >= checkStart.start.slice(0, 5) && pickedStart <= checkStart.end.slice(0, 5)
        );
        checkEnd = timeSlotToEdit.find(
         (checkEnd) =>
          //Issue on only picked end
          //picked end bigger than existed start and smaller than existed end
          pickedEnd >= checkEnd.start.slice(0, 5) && pickedEnd <= checkEnd.end.slice(0, 5)
        );
        checkBetween = timeSlotToEdit.find(
         (checkBetween) =>
          //Issue on picked start and picked end
          //picked start smaller than existed start and picked end smaller than existed end
          checkBetween.end.slice(0, 5) <= pickedEnd && pickedStart <= checkBetween.start.slice(0, 5)
        );
       }
      } else if (pickedStartInt >= pickedEndInt) {
       //picked start bigger than picked end
       this.pickedStartBigger = true;
      }
     } else {
      const res = this.call_queue_group_time_spans.filter(
       (call_queue_group) => call_queue_group.fullDate === value
      );

      if (res.length > 0 && pickedStartInt < pickedEndInt) {
       for (let index = 0; index < res.length; index++) {
        const timeSpans = res[index];
        checkDay.push(timeSpans);
        timeSlotToEdit = checkDay.filter((day) => day.id != this.id);
        checkStart = timeSlotToEdit.find(
         (checkStart) =>
          //Issue on only picked start
          //picked start bigger than existed start and smaller than existed end
          pickedStart >= checkStart.start.slice(0, 5) && pickedStart <= checkStart.end.slice(0, 5)
        );
        checkEnd = timeSlotToEdit.find(
         (checkEnd) =>
          //Issue on only picked end
          //picked end bigger than existed start and smaller than existed end
          pickedEnd >= checkEnd.start.slice(0, 5) && pickedEnd <= checkEnd.end.slice(0, 5)
        );
        checkBetween = timeSlotToEdit.find(
         (checkBetween) =>
          //Issue on picked start and picked end
          //picked start smaller than existed start and picked end smaller than existed end
          checkBetween.end.slice(0, 5) <= pickedEnd && pickedStart <= checkBetween.start.slice(0, 5)
        );
       }
      } else if (pickedStartInt >= pickedEndInt) {
       //picked start bigger than picked end
       this.pickedStartBigger = true;
      }
     }
    }
   } else {
    //inside a callqueue detail
    for (const value of pickedDay) {
     if (typeof value == "number") {
      const res = this.call_queue_time_spans.filter(
       (call_queue_time_spans) => call_queue_time_spans.dayOfWeek === value
      );
      if (res.length > 0 && pickedStartInt < pickedEndInt) {
       for (let index = 0; index < res.length; index++) {
        const timeSpans = res[index];
        checkDay.push(timeSpans);
        timeSlotToEdit = checkDay.filter((day) => day.id != this.id);
        checkStart = timeSlotToEdit.find(
         (checkStart) =>
          //Issue on only picked start
          //picked start bigger than existed start and smaller than existed end
          pickedStart >= checkStart.start.slice(0, 5) && pickedStart <= checkStart.end.slice(0, 5)
        );
        checkEnd = timeSlotToEdit.find(
         (checkEnd) =>
          //Issue on only picked end
          //picked end bigger than existed start and smaller than existed end
          pickedEnd >= checkEnd.start.slice(0, 5) && pickedEnd <= checkEnd.end.slice(0, 5)
        );
        checkBetween = timeSlotToEdit.find(
         (checkBetween) =>
          //Issue on picked start and picked end
          //picked start smaller than existed start and picked end smaller than existed end
          checkBetween.end.slice(0, 5) <= pickedEnd && pickedStart <= checkBetween.start.slice(0, 5)
        );
       }
      } else if (pickedStartInt >= pickedEndInt) {
       this.pickedStartBigger = true;
      }
     } else {
      const res = this.call_queue_time_spans.filter(
       (call_queue_time_spans) => call_queue_time_spans.fullDate === value
      );
      if (res.length > 0 && pickedStartInt < pickedEndInt) {
       for (let index = 0; index < res.length; index++) {
        const timeSpans = res[index];
        checkDay.push(timeSpans);
        timeSlotToEdit = checkDay.filter((day) => day.id != this.id);
        checkStart = timeSlotToEdit.find(
         (checkStart) =>
          //Issue on only picked start
          //picked start bigger than existed start and smaller than existed end
          pickedStart >= checkStart.start.slice(0, 5) && pickedStart <= checkStart.end.slice(0, 5)
        );
        checkEnd = timeSlotToEdit.find(
         (checkEnd) =>
          //Issue on only picked end
          //picked end bigger than existed start and smaller than existed end
          pickedEnd >= checkEnd.start.slice(0, 5) && pickedEnd <= checkEnd.end.slice(0, 5)
        );
        checkBetween = timeSlotToEdit.find(
         (checkBetween) =>
          //Issue on picked start and picked end
          //picked start smaller than existed start and picked end smaller than existed end
          checkBetween.end.slice(0, 5) <= pickedEnd && pickedStart <= checkBetween.start.slice(0, 5)
        );
       }
      } else if (pickedStartInt >= pickedEndInt) {
       this.pickedStartBigger = true;
      }
     }
    }
   }

   return { checkStart, checkEnd, checkBetween };
  },
  sendMessage(msg, subMsg) {
   this.showMessage = true;
   this.messageToShow = msg;
   this.subMessageToShow = subMsg;
  },
 },
 mounted() {
  this.getFrenchHolidaysOver12Months();
  if (this.callQueueGroupTimeSlot) {
   this.form.dayOfWeek = this.callQueueGroupTimeSlot.dayOfWeek;
   this.form.start = this.callQueueGroupTimeSlot.start.substring(0, 5);
   this.form.end = this.callQueueGroupTimeSlot.end.substring(0, 5);
   this.form.reference = this.callQueueGroupTimeSlot.reference;
   this.form.fullDate = this.callQueueGroupTimeSlot.fullDate;
   this.form.destination = this.callQueueGroupTimeSlot.destination;
  }
 },
 computed: {
  computedTransition() {
   return this.withTransition && "fade";
  },
 },
};
</script>

<style></style>
